// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1RQZF","title":"Images90_title__3Eu7l","images":"Images90_images__303Be"};